import Vue from 'vue'
import Constants from 'Constants'
import RootMarketplaceMixin from 'GroomyRoot/mixins/Marketplace.js'
import Common from 'GroomyRoot/assets/js/common.js'


export default Vue.util.mergeOptions(RootMarketplaceMixin, {
    methods: {
        /**
         * Vérifie le statut d'un paiement marketplace (duedates ou invoice details).
         * @param {string} type - 'duedates' ou 'details'
         * @param {Array<number>} ids - Identifiants des duedates ou invoice details.
         * @returns {Object|null} { status: 'success'|'pending'|'error', invoice_ids: [...] }
         */
        checkMarketplacePaymentResult: async function(type, ids) {
            const url = Constants.MARKETPLACE_PAYMENT_RESULT_URL + '?licence_key=' + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("MarketplaceMixin::checkMarketplacePaymentResult", url, { type, ids }, false)
                .catch(error => {
                    console.error("MarketplaceMixin::checkMarketplacePaymentResult => ERROR", error)
                    return null
                })
            if (result && result.retour) return result.retour
            return null
        },

        /**
         * Construit la liste des montants à régler, regroupés par date d'échéance et triés
         * chronologiquement. Les échéances déjà exigibles sont rassemblées sur la date du jour.
         *
         * Les cumuls se font en centimes entiers : additionner des montants en euros ferait
         * ressortir les résidus de la base 2 (7348.3099999999995 pour 7348,31 €).
         *
         * Le composant consommateur doit inclure le mixin Tools (pour formatDate).
         *
         * @param {Array<Object>} items Éléments à totaliser.
         * @param {Object} accessors
         * @param {Function} accessors.dateOf Date d'échéance d'un élément, au format YYYY-MM-DD.
         * @param {Function} accessors.centsOf Montant d'un élément, en centimes.
         * @param {Function} accessors.currencyOf Code devise d'un élément.
         * @returns {Promise<Array<Object>>} Entrées { is_now, date_label, formatted } pour AmountsToPay.
         */
        buildAmountsToPay: async function(items, { dateOf, centsOf, currencyOf }) {
            const today = new Date()
            today.setHours(0, 0, 0, 0)

            const totals = {}
            for (const item of items) {
                const due_date = dateOf(item)
                const date = new Date(due_date + " 00:00:00")
                const is_now = date <= today
                const key = is_now ? today.toISOString() : date.toISOString()

                if (totals[key] === undefined) {
                    totals[key] = { is_now: is_now, date_label: this.formatDate(due_date), currency: currencyOf(item), cents: 0 }
                }
                totals[key].cents += centsOf(item)
            }

            const sorted = Object.keys(totals).sort().map(key => totals[key])
            return Promise.all(sorted.map(async total => ({
                is_now:     total.is_now,
                date_label: total.date_label,
                formatted:  await Common.priceFormat(total.cents / 100, total.currency, true)
            })))
        },
    }
})